import { T } from "@repo/transifex";
import { LogoErrorEmail } from "~/components/kiosk/svgs/email-error";

import { Modal } from "../../shared/modal";
import { ModalButton } from "../../shared/modal-button";
import { ModalTitle } from "../../shared/modal-title";

type ModalEmailErrorProps = {
  onClick: () => void;
};

export const ModalEmailError = ({ onClick }: ModalEmailErrorProps) => {
  return (
    <Modal backdropVariant="error">
      <div className="flex flex-col items-center gap-y-16">
        <LogoErrorEmail />

        <ModalTitle size="8xl" variant="error" weight="black">
          <T _str="Email failed" />
        </ModalTitle>
        <p className="text-5xl font-extralight text-kiosk-background-primary">
          <T _str="Please try again or contact staff" />
        </p>
        <ModalButton onClick={onClick} variant="error" size="medium">
          <T _str="Try again" />
        </ModalButton>
      </div>
    </Modal>
  );
};
